/** Object for cart upsell hierarchy */
export default function getUpsellHierarchy() {
	 const upsellHierarchy = [
		{	
			"name" : "bras",
			"priority" : 7,
			"productTypes": [
				't-shirt',
				'push up',
				'contour',
				'underwire',
				'balconette',
				'strapless',
				'plunge'
			]
		},
	 	{
			"name": "bralettes",
			"priority" : 6,
			"productTypes": [
				"bralette",
				"wirefree"
			]
		},
		{
			"name": "undies",
			"priority": 5,
			"productTypes": [
				'hi leg',
				'bikini',
				'hipster',
				'thong',
				'cheeky',
				'boyshort',
				'tanga',
				'shorty',
				'hikini'
			]
		},
		{
			"name": "swim",
			"priority": 4,
			"productTypes": [
				"swim bottoms",
				"swim one pieces",
				"swim rashguard",
				"swim top",
				"sale-swim top",
				"sale-swim bottoms"
			]
		},
		{
			"name": "lounge",
			"priority": 3,
			"productTypes": [
				'chemise',
				'cami',
				'bodysuit',
				'garter belts'
			]
		},
		{
			"name": "active",
			"priority" : 2,
			"productTypes": [
				"active bottoms",
				"active bras",
				"sale-active bottoms",
				"sale-active bras"
			]
		},
		{
			"name": "merch",
			"priority": 1,
			"productTypes":[
				"accessories"
			]
		}
	]
 return upsellHierarchy
}